function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f1f1f1}.cls-2{fill:#bab8b8}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6620",
  d: "M14.456 0A14.456 14.456 0 1 1 0 14.456 14.456 14.456 0 0 1 14.456 0z",
  className: "cls-1",
  "data-name": "Path 6620"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "miscellaneous_2_",
  "data-name": "miscellaneous (2)",
  transform: "translate(9 8.665)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6769",
  d: "M14.965 1.857v-.464A1.4 1.4 0 0 0 13.572 0h-.929a1.4 1.4 0 0 0-1.393 1.393v.464H8v.929h10.215v-.929zm-2.786-.464a.465.465 0 0 1 .464-.464h.929a.465.465 0 0 1 .464.464v.464h-1.857z",
  className: "cls-2",
  "data-name": "Path 6769",
  transform: "translate(-8)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6770",
  d: "M18.467 62.654a1.392 1.392 0 0 0 1.384 1.239h4.839a1.392 1.392 0 0 0 1.384-1.239l.74-6.654h-9.086zm5.663-5.764l.925.077-.464 5.572-.925-.077zm-2.323.039h.929V62.5h-.929zm-1.395-.039l.464 5.572-.925.077-.464-5.572z",
  className: "cls-2",
  "data-name": "Path 6770",
  transform: "translate(-17.163 -52.75)"
}));

function SvgDeleteBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    width: 28.911,
    height: 28.911,
    viewBox: "0 0 28.911 28.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBank);
export default __webpack_public_path__ + "static/media/delete-bank.56dbe60f.svg";
export { ForwardRef as ReactComponent };